<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>积分流水</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="back">返回</el-button>
      </div>
      <el-table :data="userData" style="width: 100%">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="logUser" label="用户名"></el-table-column>
        <el-table-column prop="logData" label="当前剩余次数"></el-table-column>
        <el-table-column prop="logMsg" label="上次剩余次数"></el-table-column>
        <el-table-column prop="logType" label="流水类型">
          <template scope="scope">
            {{scope.row.logType == 1 ? '训练课程': scope.row.logType == 2 ? '中医诊疗': '未知'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" sortable label="流水创建时间"></el-table-column>
      </el-table>
      <div class="page-box">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageAll"
          @current-change="goPage"
        ></el-pagination>
      </div>
      <div class="btn-box">
        <el-button class="saveBtn" @click="back" type="primary">返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      userData: [],
      loading: false,
      pageAll: 1
    };
  },
  mounted() {
    this.getUser(10, 1);
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    goPage(e) {
      this.getUser(10, e);
    },
    //获取用户详情
    getUser(size, num) {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/queryLog", {
        // .get("/gymTest/queryLog", {
          params: {
            logUser: that.$route.query.userName,
            pageSize: size,
            pageNum: num,
          }
        })
        .then(res => {
          that.userData = res.data.data.list;
          that.pageAll = res.data.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.form {
  overflow: hidden;
}
.box {
  width: 48%;
  float: left;
}
.wd50 {
  width: 47%;
}
.wd100 {
  width: 100%;
}
.mr {
  margin-right: 6%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.btn-box {
  text-align: center;
  margin: 20px auto;
}
.page-box {
  background: #fff;
  text-align: center;
  padding: 20px 0;
}
</style>
